import React from "react";
import { Helmet } from "react-helmet";

function HelmetTitleProvider({ title }) {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
}

export default HelmetTitleProvider;
